import debounce from 'lodash.debounce'
import React/* , { useEffect } */ from 'react'
import { HelpCircle } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  FormDashboardLabel as Label,
  FormDashboardInput as Input,
  // FormDashboardTextarea as Textarea,
  FormRow,
  Radio,
  MediaUploader,
  FileUploaderWithPreview,
} from '../../../components'
import DevLogger from '../../../components/_dev-logger'
import { useInternationalization } from '../../../features/i18n'
import { updateForm } from '../../../features/resource-form/slice'
import { FormMethodType } from './form-method-type'

const FormResourceType = ({ onChange = (e) => console.log(e) }) => {
  const dispatch = useDispatch()
  const [form, setForm] = React.useState({
    type: 1,
    embedLink: 'https://',
    description_en: 'N/A',
    description_id: 'N/A',
    method_type: 'embed'
  })
  const { translate, language } = useInternationalization()
  const resourceTypes = useSelector(state => state.system.resourceTypes)

  const handleInput = debounce((e) => {
    if(e.target && e.target !== null){
      const newForm = {
        ...form,
        [e.target.name]: e.target.value
      }

      setForm(newForm)
    }
  }, 250)

  React.useEffect(() => {
    console.log(form)
    dispatch(updateForm({key: 'file', value: form}))
    //eslint-disable-next-line
  }, [form])

  const handleRadio = (e) => {
    console.log(e)
    handleInput(e)
  }

  return (
    <>
      <FormRow last>
        <Label>
          <div className="flex items-center">
            <div>{translate('SEARCH', 'resource_type')}</div>
            <Link className="ml-2 opacity-50" to="/example/embed-link" target="_blank" rel="noopener noreferrer"><HelpCircle width={14} height={14}/></Link>
          </div>
        </Label>

        <DevLogger data={form}/>

        {
          (resourceTypes && resourceTypes.length > 0) &&
          <div className="flex flex-wrap lg:items-center mb-4 pt-1">
            {
              resourceTypes.map((resourceType, index) => (
                <div className="w-1/2 lg:w-auto" key={resourceType.id}>
                  <Radio
                    name="type"
                    id={`type${index}`}
                    value={resourceType.id}
                    label={resourceType.name[language.name]}
                    className="mr-5 mb-2 lg:mb-0"
                    form={form}
                    onChange={handleRadio}
                  />
                </div>
              ))
            }
          </div>
        }
        {
          // Embed link
          form.type === 1 &&
          <Input
            name="embedLink"
            className="w-full"
            placeholder="Example: https://embedsource.com/file-slug-goes-here.pdf"
            defaultValue={form.embedLink}
            onChange={(e) => {e.persist(); handleInput(e)}}
          />
        }
        {
          // Upload file
          form.type !== 1 &&
          <FormMethodType form={form} handleInput={handleInput} />
        }
        {
          form.type === 'download' &&
          <FileUploaderWithPreview />
        }
        {
          form.type === 'document' &&
          <MediaUploader type="Document"/>
        }
        {
          form.type === 'video' &&
          <MediaUploader type="Video"/>
        }
        {
          form.type === 'audio' &&
          <MediaUploader type="Audio"/>
        }
      </FormRow>
    </>
  )
}

export { FormResourceType }
